// Convert an uploaded signature photo (dark ink on light paper) into a
// transparent PNG: light pixels become transparent, dark ink is kept.
// Mirrors the backend algorithm (lum ramp 110..205, crop to ink, resize<=700w).

const LO = 110;
const HI = 205;
const MAX_W = 520;

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const im = new Image();
    im.onload = () => resolve(im);
    im.onerror = reject;
    im.src = src;
  });
}

export async function processSignatureDataUrl(dataUrl) {
  const img = await loadImage(dataUrl);
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  const id = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const d = id.data;
  let minX = canvas.width, minY = canvas.height, maxX = 0, maxY = 0, found = false;
  for (let i = 0; i < d.length; i += 4) {
    const lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
    let a = (HI - lum) / (HI - LO);
    a = a < 0 ? 0 : a > 1 ? 1 : a;
    let alpha = Math.round(a * 255);
    if (alpha < 40) alpha = 0; // drop faint paper noise
    d[i + 3] = alpha;
    if (alpha > 30) {
      const px = (i / 4) % canvas.width;
      const py = Math.floor(i / 4 / canvas.width);
      if (px < minX) minX = px;
      if (px > maxX) maxX = px;
      if (py < minY) minY = py;
      if (py > maxY) maxY = py;
      found = true;
    }
  }
  ctx.putImageData(id, 0, 0);

  // crop to ink bbox with padding
  const pad = 8;
  let cw = canvas.width, ch = canvas.height, sx = 0, sy = 0;
  if (found) {
    sx = Math.max(minX - pad, 0);
    sy = Math.max(minY - pad, 0);
    cw = Math.min(maxX + pad, canvas.width) - sx;
    ch = Math.min(maxY + pad, canvas.height) - sy;
  }
  // resize so width <= MAX_W
  const scale = cw > MAX_W ? MAX_W / cw : 1;
  const out = document.createElement("canvas");
  out.width = Math.round(cw * scale);
  out.height = Math.round(ch * scale);
  const octx = out.getContext("2d");
  octx.imageSmoothingQuality = "high";
  octx.drawImage(canvas, sx, sy, cw, ch, 0, 0, out.width, out.height);
  return out.toDataURL("image/png");
}

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function processSignatureFile(file) {
  const dataUrl = await fileToDataUrl(file);
  return processSignatureDataUrl(dataUrl);
}
